export const PRAGMATIC_DEMO_CONFIG = {
  CODE: "JU02",
  ID: 44,
  CURRENCIES: ["PEN", "USD", "EUR"],
  PLAYERS: [
    { id: "43298", username: "1308266932294", label: "demo11", currency: "PEN", country: "PE" },
    { id: "43311", username: "2244542973027", label: "demo12", currency: "PEN", country: "PE" },
    { id: "43314", username: "9831710359141", label: "demo13", currency: "PEN", country: "PE" },
    { id: "43409", username: "8229576944463", label: "demo15", currency: "USD", country: "PE" },
    { id: "43315", username: "0265873539404", label: "demo12EUR", currency: "EUR", country: "PE" }
  ]
};

const clean = (value) => String(value ?? "").trim();

export function isPragmaticDemoClient(clientOrCode, clientId = "") {
  const client = clientOrCode && typeof clientOrCode === "object" ? clientOrCode : null;
  const code = clean(
    client?.code ?? client?.clientCode ?? (client ? "" : clientOrCode),
  ).toUpperCase();
  const id = clean(client?.id ?? client?.clientId ?? clientId);

  return code === clean(PRAGMATIC_DEMO_CONFIG.CODE).toUpperCase()
    || id === clean(PRAGMATIC_DEMO_CONFIG.ID);
}

export function getPragmaticDemoPlayers(clientOrCode, clientId = "", currency = "") {
  if (!isPragmaticDemoClient(clientOrCode, clientId)) return null;

  const normalizedCurrency = clean(currency).toUpperCase();
  return PRAGMATIC_DEMO_CONFIG.PLAYERS
    .filter((player) => !normalizedCurrency || clean(player.currency).toUpperCase() === normalizedCurrency)
    .map((player) => ({
      ...player,
      id: clean(player.id),
      value: clean(player.id),
      username_origin: clean(player.label ?? player.username ?? player.id),
      country: clean(player.country),
    }));
}
